import { render, staticRenderFns } from "./starProduct.vue?vue&type=template&id=929225c8&scoped=true&"
import script from "./starProduct.vue?vue&type=script&lang=ts&"
export * from "./starProduct.vue?vue&type=script&lang=ts&"
import style0 from "./starProduct.vue?vue&type=style&index=0&id=929225c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929225c8",
  null
  
)

export default component.exports